export const authRole = {
  Admin: ['admin'],
  User: ['user', 'admin'],
};

export const RoutePermittedRole = {
  Admin: 'Administrator',
  Pegawai: 'Pegawai',
  Operator: 'Operator',
  Viewer: 'Viewer',
  OperatorEselon1: 'Operator Eselon 1',
  'Admin360': 'Admin Penilaian 360',
  'Operator360': 'Operator Penilaian 360',
};
export const defaultUser = {
  displayName: 'John Alex',
  email: 'demo@example.com',
  token: 'access-token',
  role: 'user',
  photoURL: '/assets/images/avatar/A11.jpg',
};
export const initialUrl = '/dashboard'; // this url will open after login
